export { default } from "./SkeletonOrdersList-component";
